(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["air-jordan-4"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-2021"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-2024"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-apr-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-apr-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-april"]) return;
  try {
    
$(document).ready(function() {
	if ( $('.found-schedules').html() == 0 ) { 
		$(".found-schedules").addClass('blank-schedule');
		$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">April\'s lineups are available on shop now.</div></div>');
	};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-aug-2020"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-aug-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-aug-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-dec-2021"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-dec-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-dec-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-family-pack"]) return;
  try {
    
$(document).ready(function() {
	if ( $('.found-schedules').html() == 0 ) { 
		$(".found-schedules").addClass('blank-schedule');
		$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
	};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-feb-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-feb-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-feb-2024"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-his-hers-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-holiday-2021"]) return;
  try {
    
$(document).ready(function() {
	if ( $('.found-schedules').html() == 0 ) { 
		$(".found-schedules").addClass('blank-schedule');
		$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
	};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-jan-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-jan-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-jan-2024"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-jul-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-jul-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-july"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-jun-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-jun-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-june"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-mar-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-mar-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-march"]) return;
  try {
    
$(document).ready(function() {
	if ( $('.found-schedules').html() == 0 ) { 
		$(".found-schedules").addClass('blank-schedule');
		$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">March\'s lineups are available on shop now.</div></div>');
	};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-may-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-may-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-nov-2021"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-nov-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-nov-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-oct-2021"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-oct-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-oct-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-sep-2021"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-sep-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-sep-2023"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-spring-2022"]) return;
  try {
    
$(document).ready(function() {
if ( $('.found-schedules').html() == 0 ) { 
$(".found-schedules").addClass('blank-schedule');
$(".found-schedules").append('<div class="one-half-column-left" style="padding-top: 19px;"> <div class="rte">'+ $(".pagecontent").html() +'</div></div>');
};
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-template"]) return;
  try {
    

function loadJSONcollection() {
	console.log("triggered");
	$.ajax({
		url:	"/admin/api/2021-01/products.json?limit=2",
		type:	'GET'
	})
	.done(function(data) {
		var productList = data;
		console.dir(productList);
        $(productList.products).each(function(index){
			console.log(this.title);
		});
	})
	.fail(function(data) {})
	.always(function(data) {});
}

loadJSONcollection();




  } catch(e) { console.error(e); }
})();

})();
